import { render, staticRenderFns } from "./WorkReadOnlyTextField.vue?vue&type=template&id=30fad073&scoped=true"
import script from "./WorkReadOnlyTextField.vue?vue&type=script&lang=js"
export * from "./WorkReadOnlyTextField.vue?vue&type=script&lang=js"
import style0 from "./WorkReadOnlyTextField.vue?vue&type=style&index=0&id=30fad073&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fad073",
  null
  
)

export default component.exports